export const regular = [
  [132, 152, 198],
  [160, 184, 240],
  [172, 198, 258],
  [184, 212, 276],
  [212, 244, 318],
  [240, 276, 360],
  [284, 327, 426],
  [308, 354, 462],
];

export const moveInOut = [
  [236, 271, 354],
  [260, 299, 390],
  [292, 336, 438],
  [328, 377, 492],
  [360, 414, 540],
  [396, 455, 594],
  [440, 506, 660],
  [476, 547, 714],
];

export const minorPostConstruction = [
  [208, 239,312],
  [230, 265, 346],
  [269, 309, 403],
  [317, 364, 475],
  [352, 405, 528],
  [394, 453, 590],
  [448, 515, 672],
  [509, 585, 763],
];

export const majorPostConstruction = [
  [260, 299, 390],
  [288, 331, 432],
  [336, 386, 504],
  [396, 455, 594],
  [440, 506, 660],
  [492, 566, 738],
  [560, 644, 840],
  [636, 731, 954],
];

export const pets = [15, 20, 25, 30, 35, 40, 45, 50, 55];

const kitchenBase = [
  'Appliance exteriors',
  'Microwave inside',
  'Countertops & backsplash',
  'Under small appliances',
  'Sinks & faucets disinfected',
  'Vacuum & mop floors',
  'Trash emptied',
  'Table & chairs wiped'
];

const kitchenDeep = [
  ...kitchenBase,
  'Top of fridge cleaned',
  'Cabinet fronts wiped',
  'Stove burners & knobs wiped',
  'Trash can top wiped',
]

const kitchenMoveOut = [
  ...kitchenDeep,
  'Pantry shelves wiped'
];

const bathroomBase = [
  'Showers & tubes disinfected',
  'Sinks & faucets disinfected',
  'Toilets disinfected inside/out',
  'Countertops wiped',
  'Vanity exteriors wiped',
  'Mirrors cleaned',
  'Vacuum & mop floors',
  'Trash emptied'
];

const bathroomDeep = [
  ...bathroomBase,
  'Doors wiped',
  'Cabinet fronts wiped',
  'Shower heads cleaned',
];

const bathroomMoveOut = [
  ...bathroomDeep,
  'Medicine cabinets inside',
];

const bedroomBase = [
  'Furniture dusted',
  'Beds made',
  'Vacuum floors',
  'Vacuum closets (by request)',
  'Light tidying up'
];

const laundryBase = [
  'Vacuum & mop floors',
  'Washer & dryer exteriors wiped',
];

const laundryDeep = [
  ...laundryBase,
  'Empty dryer lint trap',
  'Between washer & dryer area'
]

const allAreasBase = [
  'Ceiling fans dusted, under 10\'',
  'Furniture dusted, under 8\'',
  'Light tidying up',
  'Switches & door knobs wiped',
  'Sliding doors cleaned inside/out',
  'Picture frames dry dusted'
];

const allAreasDeep = [
  ...allAreasBase,
  'Doors & door frames wiped',
  'Sliding door track wiped',
  'Vents dry dusted',
  'Couches & cushions vacuumed',
  'Window blinds dry dusted',
  'Window ledges dry dusted',
  'Baseboards dry dusted',
  'Banisters, handrails wiped'
];

const allAreasMoveOut = [
  ...allAreasDeep,
  'Closet shelves wiped'
];

export const regularServices = [{
  name: 'Kitchen',
  items: kitchenBase,
}, {
  name: 'Bathrooms',
  items: bathroomBase,
}, {
  name: 'Bedrooms',
  items: bedroomBase,
}, {
  name: 'Laundry Area',
  items: laundryBase,
}, {
  name: 'All Areas',
  items: allAreasBase,
}];

export const deepServices = [{
  name: 'Kitchen',
  items: kitchenDeep,
}, {
  name: 'Bathrooms',
  items: bathroomDeep,
}, {
  name: 'Bedrooms',
  items: bedroomBase,
}, {
  name: 'Laundry Area',
  items: laundryDeep,
}, {
  name: 'All Areas',
  items: allAreasDeep,
}];

export const moveOutServices = [{
  name: 'Kitchen',
  items: kitchenMoveOut,
}, {
  name: 'Bathrooms',
  items: bathroomMoveOut,
}, {
  name: 'Bedrooms',
  items: bedroomBase,
}, {
  name: 'Laundry Area',
  items: laundryDeep,
}, {
  name: 'All Areas',
  items: allAreasMoveOut,
}];

export const postConstructionServices = [...moveOutServices];

export const excludedServices = [{
  name: 'Excluded Services (including but not limited to)',
  items: [
    "Carpet cleaning",
    "Lifting over 20 lbs",
    "Trash hauling",
    "Bug extermination",
    "Washing walls",
    "Electronics, e.g. TVs",
    "Washing light bulbs",
    "Heavily soiled areas",
    "Black mold",
    "Feces, blood, etc",
    "Clutter pickup",
    "Moving furniture",
    "Vertical blinds",
    "Hoarder conditions",
    "Grout cleaning",
    "Biohazard material",
    "Permanent stains",
    "Bug infestations",
    "Exterior windows",
    "Trinkets, crafts, etc"
  ]
}];